/* eslint-disable */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { getDateFormat, getTimeFormat } from 'legacy/constants';

const FormattedDate = props => {
  const dispatch = useDispatch();
  const me = useSelector(state => state.app.dataSources.me);
  const { fmt, date, id } = props;

  const getDate = d => {
    if (!d) {
      return '-';
    }

    const defaultFmt = `${getDateFormat(me)} ${'\n'} ${getTimeFormat(me)}`;
    const displayFormat = fmt || defaultFmt;
    return moment(d).calendar(null, {
      nextDay: displayFormat,
      nextWeek: displayFormat,
      lastWeek: displayFormat,
      sameElse: displayFormat,
      sameDay: displayFormat,
      lastDay: displayFormat,
    });
  };

  // in older browsers as Chrome77 JS Function replaceAll('-', '/') not working, replacing the replaceAll function with replace
  // return <span id={id}>{getDate(date).replaceAll('-', '/')}</span>;
  return <span id={id}>{getDate(date).replace(/-/g, '/')}</span>;
};

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/views/components/Common/FormattedDate/FormattedDate.jsx